import * as React from 'react'
import { IActiveTripResponseV2 } from '../../../types'
import ImageView from '../../ui/ImageView'
import { mapViewStrategyStages } from '../../MapView'
import ETADisplay from './ETA'
import TripPaymentDisplay from './TripRiderDetails'

export interface ITripEnRouteProps {
  currentTrip: IActiveTripResponseV2
  getTripById: (tripId: string) => void
  setCurrentTripStage: (stage: string) => void
}

class TripEnRoute extends React.Component<ITripEnRouteProps> {
  private static INTERVAL = 60000

  private tripTimerId: ReturnType<typeof setInterval>

  public componentDidMount() {
    this.tripTimerId = setInterval(this.refreshTrip, TripEnRoute.INTERVAL)
    this.props.setCurrentTripStage(mapViewStrategyStages.liveTrip)
  }

  public componentWillUnmount() {
    clearInterval(this.tripTimerId)
  }

  public render() {
    const trip = this.props.currentTrip
    console.log('showing a trip: ', trip)

    if (!trip) {
      return null
    }

    const etaOrigin = trip.operatorLocation
      ? {
          lat: trip.operatorLocation.coordinates[1],
          lng: trip.operatorLocation.coordinates[0]
        }
      : null
    const etaDestination = trip.operatorLocation
      ? {
          lat: trip.dropoffLocation.latitude,
          lng: trip.dropoffLocation.longitude
        }
      : null

    const operatorName = trip.operator ? `${trip.operator.firstName} ${trip.operator.lastName}` : 'No operator assigned'
    const operatorPhone = trip.operator ? trip.operator.phone : ''

    const vehicleInfo = trip.vehicle ? `${trip.vehicle.make} ${trip.vehicle.model}` : 'No vehicle assigned'

    const licensePlate = trip.vehicle ? trip.vehicle.licensePlate : 'No Plate'

    const paymentMode =
      trip.tripsGroupRides[0] && trip.tripsGroupRides[0].fareType
        ? trip.tripsGroupRides[0].fareType
        : trip.paymentMode || 'Wallet'

    return (
      <div className='px2 py2'>
        <div className='flex '>
          <ImageView entityId={trip.operator ? trip.operator.id : undefined} width='40px' height='40px' />
          <div className='col-10 pl2'>
            <div className='flex'>
              <p className='m0 font-black'>{operatorName}</p>
            </div>
            <div className='h6 font-grey2'>
              {trip.service.name} {trip.product.name}
            </div>
          </div>
        </div>
        <div className='h6 font-grey2 pl1 mt1'>
          <span className='h6 font-black mr1'>Notes:</span>
          {trip.notes}
        </div>
        <TripPaymentDisplay
          tripsGroupRides={trip.tripsGroupRides}
          paymentMode={paymentMode}
          serviceId={trip.service.serviceId}
          tripId={trip.id}
          riderCount={trip.riderCount}
        />

        <div className='col-12'>
          <div className='flex items-center justify-between mt2 h6'>
            <p className='m0 font-black'>{vehicleInfo}</p>
            <div>
              <p className='car-number'>{licensePlate}</p>
            </div>
          </div>
          {/* <TripActivityLog currentTrip={this.props.currentTrip} /> */}

          <div>
            <div className='flex items-center justify-between mt1 h6'>
              <p className='m0 font-black'>Estimated Dropoff</p>
              <p className='m0'>
                <ETADisplay origin={etaOrigin} destination={etaDestination} />
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  private refreshTrip = () => {
    this.props.getTripById(this.props.currentTrip.id)
  }
}

export default TripEnRoute



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/TripEnRoute.tsx